import React from 'react';
import styled from 'styled-components';
import { Document } from 'talent_matching/types';
import DocumentContent from './document_content';

const PreviewContainer = styled.div<{ clickable: boolean }>`
  cursor: ${(props) => (props.clickable ? 'pointer' : 'default')};
  position: relative;
  min-width: 600px;
  height: 100%;

  /* Create overlay to capture clicks while still displaying the iframe */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    display: ${(props) => (props.clickable ? 'block' : 'none')};
  }
`;

export interface DocumentPreviewProps {
  document: Document | null;
  onClick?: () => void;
  hasCalibrationTerms?: boolean;
}

const DocumentPreview = ({
  document,
  onClick,
  hasCalibrationTerms,
}: DocumentPreviewProps) => {
  return (
    <PreviewContainer onClick={onClick} clickable={Boolean(onClick)}>
      <DocumentContent
        document={document}
        hasCalibrationTerms={hasCalibrationTerms}
      />
    </PreviewContainer>
  );
};

export default DocumentPreview;
